import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output, Signal, inject, input } from '@angular/core';

import { BetslipType } from '../../../../../../core/betslip-type';
import { SummaryErrorsViewModel } from '../../../../../validation/components/common/errors-container.component';
import { BetslipError } from '../../../../../validation/errors/betslip-error';
import { LinearComboModuleErrorViewModelService } from '../../../../services/linear/linear-combo-module-error-viewmodel.service';

@Component({
    selector: 'bs-linear-combo-bet-container-errors',
    template: '<bs-errors-container [viewModel]="viewModel()" (errorDisplayChange)="errorDisplayChange.emit($event)"></bs-errors-container>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearComboBetContainerErrorsComponent {
    @HostBinding('class') className = 'bs-digital-errors';

    @Output() errorDisplayChange = new EventEmitter<boolean>();

    private readonly errorViewModelService: LinearComboModuleErrorViewModelService = inject(LinearComboModuleErrorViewModelService);

    readonly errors = input.required<BetslipError[]>();
    readonly hasComboPrevention = input.required<boolean>();
    readonly betslipType = input.required<BetslipType>();

    readonly viewModel: Signal<SummaryErrorsViewModel> = this.errorViewModelService.getErrorViewModel(
        this.errors,
        this.hasComboPrevention,
        this.betslipType,
    );
}
